import React from 'react';
import { StyledLink } from './styles';
import useBodega from './../../utils/hooks/bodegaHook';

function SkipToContent() {
  const label = useBodega('nav_skip_to_content', 'Skip to main content');
  return <StyledLink href="#skip-to-content">{label}</StyledLink>;
}

export default SkipToContent;
